module.exports = __webpack_public_path__ + "static/bg-bente-2-270213c18a6d861d5c1bfc2d5e87cd49.jpg";